import {
  hoMstDelete,
  hoMstExport,
  hoMstFetch,
  hoMstImport,
  hoMstListRequest,
  hoMstRegistration,
  hoMstUpdate,
} from '@libs/templates/mst';
import { CustomMstListSearchRaw, CustomMstRegistration, CustomMstRegistrationRaw } from '../models';

const CUSTOM_MST_URL = '/custom-mst';

const customMstUrlByKey = (customFieldKey: number) =>
  CUSTOM_MST_URL + customFieldKey.toString().padStart(2, '0');

const register = (customFieldKey: number) =>
  hoMstRegistration(customMstUrlByKey(customFieldKey), CustomMstRegistrationRaw);

const listRequest = (customFieldKey: number) =>
  hoMstListRequest(customMstUrlByKey(customFieldKey), CustomMstListSearchRaw, CustomMstRegistration);

const doExport = (customFieldKey: number) =>
  hoMstExport(customMstUrlByKey(customFieldKey), CustomMstListSearchRaw);

const fetchMst = (customFieldKey: number) =>
  hoMstFetch(customMstUrlByKey(customFieldKey), CustomMstRegistration);

const update = (customFieldKey: number) =>
  hoMstUpdate(customMstUrlByKey(customFieldKey), CustomMstRegistrationRaw);

const remove = (customFieldKey: number) => hoMstDelete(customMstUrlByKey(customFieldKey));

const importFunction = (customFieldKey: number) => hoMstImport(customMstUrlByKey(customFieldKey));

export { doExport, fetchMst, importFunction, listRequest, register, remove, update };
